import { render, staticRenderFns } from "./FacesDente.vue?vue&type=template&id=ce4e000c&scoped=true"
import script from "./FacesDente.vue?vue&type=script&lang=js"
export * from "./FacesDente.vue?vue&type=script&lang=js"
import style0 from "./FacesDente.vue?vue&type=style&index=0&id=ce4e000c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4e000c",
  null
  
)

export default component.exports